module.exports = __webpack_public_path__ + "media/images/qr/rounded-ea8b82bd41a912d5a504d813028c76da.png";